//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // 已选列表
    persons: {
      default: function _default() {
        return [];
      },
      type: Array
    }
  }
};